import React from "react";
import { Link } from "react-router-dom";
import { FaYoutube,FaInstagram } from "react-icons/fa";
import o1 from '../images/officeimage/o1.jpg';
import o2 from '../images/officeimage/o2.jpg';
import o3 from '../images/officeimage/o3.jpg';
import o4 from '../images/officeimage/o4.jpg';
import o5 from '../images/officeimage/o5.jpg';
import o6 from '../images/officeimage/o6.jpg';
function SocialBanner() {
  return (
    <>
            <div className="container-fluid">
                <div className="container">
                    <h2 className="text-center py-5">Stay Connected with Us</h2>
                    <div className="row justify-content-between">
  {/* Left Image Container */}
  <div 
    className="col-md-8 col-12" 
    style={{
      height: 'auto',       // Adapts to the image's natural height
      maxHeight: '400px',   // Limit the height for better visuals
      overflow: 'hidden',   // Prevent any content overflow
    }}
  >
    <img 
      src={o4} 
      alt="" 
      className="w-100" 
      style={{
        height: '100%',       // Scales to the container height
        width: '100%',        // Spans the full width of the container
        objectFit: 'cover',   // Ensures the image fully covers the container without distortion
      }} 
    />
  </div>

  {/* Right Image Container */}
  <div 
    className="col-md-4 col-12 border" 
    style={{
      height: 'auto',       // Adapts to the image's natural height
      maxHeight: '400px',   // Limit the height for consistency
      overflow: 'hidden',   // Prevent any content overflow
    }}
  >
    <img 
      src={o2} 
      alt="" 
      className="w-100" 
      style={{
        height: '100%',       // Scales to the container height
        width: '100%',        // Spans the full width of the container
        objectFit: 'cover',   // Ensures the image fully covers the container without distortion
      }} 
    />
  </div>
</div>

   {/* this is the second row */}
                    <div className="row justify-content-between mt-3">
                        <div className="col-md-4 col-12 border d-none d-sm-block">
                            <img src={o3} alt="" className="h-auto w-100" style={{objectFit:"100% 100%"}}/>
                        </div>
                        <div className="col-md-4 col-12">
                              <h2 className="text-center pt-5">Follow Us On  Social <br/> Media </h2>
                              <ul className="d-flex justify-content-center gap-4 pt-2">
                                <li className="list-unstyled"> <Link to="https://youtube.com/@swingtraderrs?si=7ZFJeVonMz1cJw-o">
                            <FaYoutube size={40} />
                            </Link></li>
                                <li className="list-unstyled"> <Link to="https://www.instagram.com/swingtraderrs?igsh=MTJtajNrY2ZkeTkxdw==">
                            <FaInstagram size={40} />
                            </Link></li>
                              </ul>
                        </div>
                        <div className="col-md-4 col-12 border d-none d-sm-block">
                            <img src={o1} alt=""  className="h-auto w-100" style={{objectFit:"100% 100%"}}/>
                        </div>
                    </div>

                    {/* r3rd row stsrt form here  */}

                    <div className="row justify-content-center gap-3 my-3">
                        <div className="col-md-5 col-12 border">
                            <img src={o5} className="h-auto w-100" style={{objectFit:"100% 100%"}} alt=""/>
                        </div>
                        <div className="col-md-5 col-12 border">
                            <img src={o6} className="h-auto w-100" style={{objectFit:"100% 100%"}} alt=""/>
                        </div>
                    </div>
                </div>
            </div>
    </>
  );
}

export default SocialBanner;
